var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus__auth"
  }, [_c('ValidationObserver', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('Form', {
          attrs: {
            "type": "vertical"
          },
          on: {
            "submit": function ($event) {
              return handleSubmit(_vm.onSubmit);
            }
          }
        }, [_vm.activeTypeBlock === 'code' ? [_c('div', {
          staticClass: "bonus__auth-wrap bonus__app-form-code"
        }, [_c('div', {
          staticClass: "bonus__auth-block"
        }, [_c('div', {
          staticClass: "bonus__auth-title"
        }, [_c('h2', {
          staticClass: "bonus__auth-title-text h2"
        }, [_vm._v("\n                Зарегистрируйтесь и получите\n              ")])]), _vm._v(" "), _c('p', {
          staticClass: "p mb-4 bonus__sms"
        }, [_vm._v("\n              Код отправлен на номер "), _c('br', {
          staticClass: "bonus__sms-br"
        }), _vm._v("\n              " + _vm._s(_vm.phone) + "\n            ")]), _vm._v(" "), _c('Timer', {
          attrs: {
            "time": 59
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var time = _ref2.time,
                  reactivate = _ref2.reactivate;
              return [time === 0 ? _c('div', {
                staticClass: "link link_wu link_blue bonus__code bonus__code_link",
                on: {
                  "click": function ($event) {
                    reactivate(), _vm.emit('submit', {
                      phone: _vm.phone,
                      short: true
                    });
                  }
                }
              }, [_vm._v("\n                Отправить код повторно\n              ")]) : _c('div', {
                staticClass: "bonus__code bonus__code_time"
              }, [_vm._v("\n                Выслать код повторно можно будет через " + _vm._s(time) + " сек.\n              ")])];
            }
          }], null, true)
        }), _vm._v(" "), _c('div', {
          staticClass: "form-element"
        }, [_c('FormElement', {
          staticStyle: {
            "flex-grow": "inherit"
          },
          attrs: {
            "error": _vm.checkError
          }
        }, [_c('BPInputCode', {
          attrs: {
            "loading": _vm.checkCodeAndLogin.loading,
            "error": _vm.checkCodeAndLogin.error,
            "success": _vm.checkCodeAndLogin.success
          },
          on: {
            "update:model-value": function ($event) {
              _vm.code = $event;
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "bonus__app-btns"
        }, [_vm.checkCodeAndLogin.success ? _c('button', {
          staticClass: "bonus__auth-btn bonus__auth-btn-code bonus__auth-btn_success",
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("\n                  Вы вошли в аккаунт\n                ")]) : _vm.checkCodeAndLogin.loading ? _c('button', {
          staticClass: "bonus__auth-btn bonus__auth-btn-code bonus__auth-btn_loading"
        }) : _c('button', {
          staticClass: "bonus__auth-btn bonus__auth-btn-code",
          on: {
            "click": function ($event) {
              return _vm.emit('check', {
                code: _vm.code,
                type: 'sms',
                accessToken: _vm.accessToken
              });
            }
          }
        }, [_vm._v("\n                  Отправить код\n                ")])])], 1), _vm._v(" "), _c('p', {
          staticClass: "bonus__auth-info"
        }, [_vm._v("\n              Нажимая кнопку, вы даете согласие на обработку персональных данных в соответствии с\n              "), _c('nuxt-link', {
          attrs: {
            "to": "/about/terms-of-use/"
          }
        }, [_vm._v("\n                правилами оказания услуг и политикой обработки персональных данных\n              ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "bonus__auth-layer"
        })])] : [_c('div', {
          staticClass: "bonus__auth-wrap"
        }, [_c('div', {
          staticClass: "bonus__auth-block"
        }, [_c('div', {
          staticClass: "bonus__auth-title"
        }, [_c('h2', {
          staticClass: "bonus__auth-title-text h2"
        }, [_vm._v("\n                Зарегистрируйтесь и получите\n              ")])]), _vm._v(" "), _c('p', {
          staticClass: "bonus__auth-desc"
        }, [_vm._v("\n              Дарим новым клиентам 300 бонусных рублей\n            ")]), _vm._v(" "), _c('ValidationProvider', {
          attrs: {
            "rules": "required|phone",
            "name": "телефон"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var errors = _ref3.errors;
              return [_c('FormElement', {
                attrs: {
                  "error": errors[0] || _vm.sendConfirmCodeError
                }
              }, [_c('InputPhone', {
                attrs: {
                  "theme": "bonus",
                  "model-value": _vm.phone
                },
                on: {
                  "submit": _vm.onSubmit,
                  "update:model-value": function ($event) {
                    _vm.phone = $event;
                  },
                  "input": _vm.onInput
                },
                model: {
                  value: _vm.phone,
                  callback: function ($$v) {
                    _vm.phone = $$v;
                  },
                  expression: "phone"
                }
              })], 1)];
            }
          }], null, true)
        }), _vm._v(" "), _c('div', {
          staticClass: "bonus__auth-btns"
        }, [_vm.userAuth ? _c('button', {
          staticClass: "bonus__auth-btn bonus__auth-btn_success",
          attrs: {
            "disabled": ""
          }
        }, [_c('span', {
          staticClass: "bonus__auth-btn-icon"
        }), _vm._v("У вас уже есть аккаунт\n              ")]) : _vm.sendConfirmCode.loading ? _c('button', {
          staticClass: "bonus__auth-btn bonus__auth-btn_loading"
        }) : _c('button', {
          staticClass: "bonus__auth-btn"
        }, [_vm._v("\n                Создать аккаунт\n              ")])]), _vm._v(" "), _c('p', {
          staticClass: "bonus__auth-info"
        }, [_vm._v("\n              Нажимая кнопку, вы даете согласие на обработку персональных данных в соответствии с\n              "), _c('nuxt-link', {
          attrs: {
            "to": "/about/terms-of-use/"
          }
        }, [_vm._v("\n                правилами оказания услуг и политикой обработки персональных данных\n              ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "bonus__auth-layer"
        })])]], 2)];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }